<div class="fx-row fx-wrap align-items-center justify-content-start  fx-flex-100">
    <div class="fx-row fx-wrap align-items-start justify-content-between fx-flex-100" *ngIf="organization">
        <div class="fx-column align-items-start justify-content-start">
            <span class="title bold">{{'ORGANIZATION.TAGS_TAB' | translate}}</span>
            <span class="text light">{{'ORGANIZATION.TAGS_HINT' | translate}}</span>
        </div>
        <div class="fx-row align-items-center justify-content-end">
            <button class="main-button ml-10" (click)="createTag()" roleBasedElement [roles]="['SUPERADMIN','ADMIN']">
                <div class="fx-row align-items-center justify-content-center">
                    <mat-icon class="white mr-5" fontSet="material-icons-outlined">local_offer</mat-icon>
                    {{'ORGANIZATION.CREATE_TAG' | translate}}
                </div>
            </button>
        </div>
    </div>
    <mat-divider class="mv-16 fx-flex-100"></mat-divider>
    <table mat-table [dataSource]="tags.docs" style="z-index: 0;">
        <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'TAG.LABEL' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let tag">
                <div class="fx-row align-items-center justify-content-start">
                    <div class="chip main">{{tag.label}}</div>
                </div>

            </td>
        </ng-container>
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'TAG.DESCRIPTION' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let tag">
                <span class="text" [class.light]="!tag.description">{{tag.description || '-'}}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'ACTIONS.ACTIONS' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let tag">
                <div class="fx-row align-items-center justify-content-start">
                    <button mat-icon-button (click)="editTag(tag)">
                        <mat-icon class="main" roleBasedElement [roles]="['SUPERADMIN','ADMIN']"
                            fontSet="material-icons-outlined">edit</mat-icon>
                    </button>
                    <button mat-icon-button (click)="deleteTag(tag)">
                        <mat-icon class="red" roleBasedElement [roles]="['SUPERADMIN','ADMIN']"
                            fontSet="material-icons-outlined">delete</mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
    <div class="p-16" *ngIf="tags.totalDocs === 0">
        <span class="text light">{{'ORGANIZATION.SEARCH_NO_TAGS' | translate}}</span>
    </div>
    <div class="fx-flex align-items-center justify-content-end">
        <mat-paginator [length]="tags.totalDocs || 0" [pageSize]="tags.limit || 0"
            [pageIndex]="tags.page ? (tags.page-1) : 0" [pageSizeOptions]="[10, 25, 50, 100]"
            (page)="handlePage($event)">
        </mat-paginator>
    </div>
</div>